const DEFAULT_CONFIG = {
  onHide: () => {}
}

export default {
  data () {
    return {
      config: { ...DEFAULT_CONFIG }
    }
  },
  methods: {
    destroyPopover() {
      this.config.onHide()
      this.$refs['popover'].doClose();
      document.body.removeEventListener('click', this.destroyPopover)
    },
    showPopover(dom, config = {}) {
      this.config = Object.assign({}, DEFAULT_CONFIG, config)
      this.$refs['popover'].referenceElm = dom;
      this.$refs['popover'].doShow();
      event.stopPropagation()
      document.body.addEventListener('click', this.destroyPopover)
    },
  }
}
